"use client";

// import * as React from "react";
import { motion } from "framer-motion";
// import { TrendingUp } from "lucide-react";

interface DashboardSummaryProps {
  dashboardData: {
    stats: {
      total_leads: number;
      total_projects: number;
      active_users: number;
      total_revenue: number;
      currency?: string;
    };
    quick_stats: {
      total_pipeline_value: number;
      active_leads: number;
      active_projects: number;
      won_this_month: number;
      currency?: string;
    };
    revenue_by_type: Array<{
      type: string;
      revenue: number;
      count: number;
      currency?: string;
    }>;
  } | null;
  loading: boolean;
}


const formatCurrency = (amount: number, currency: string = "USD") => {
  return `${currency} ${amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

export function DashboardSummary({ dashboardData, loading }: DashboardSummaryProps) {
  if (loading || !dashboardData) {
    return (
      <motion.div
        className="relative w-full overflow-hidden rounded-xl border border-gray-800 bg-black p-4 sm:p-6 md:p-8 text-white shadow-lg animate-pulse"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      >
        <div className="flex flex-col h-full">
          <div className="mb-4">
            <div className="h-6 w-6 bg-white/20 rounded"></div>
          </div>
          <div className="flex-grow">
            <div className="h-6 sm:h-7 md:h-8 bg-white/20 rounded w-3/4 mb-2"></div>
            <div className="h-3 sm:h-4 bg-white/20 rounded w-1/2 mb-3"></div>
            <div className="h-8 sm:h-10 md:h-12 bg-white/20 rounded w-full max-w-xs mb-2"></div>
            <div className="h-3 sm:h-4 bg-white/20 rounded w-2/3"></div>
          </div>
        </div>
        <div className="pointer-events-none absolute -bottom-2 -right-2 sm:-bottom-4 sm:-right-4 w-32 h-24 sm:w-40 sm:h-32 md:w-48 md:h-36">
          <div className="w-full h-full bg-white/10 rounded"></div>
        </div>
      </motion.div>
    );
  }

  const totalPipelineValue = dashboardData.quick_stats.total_pipeline_value;
  const currency = dashboardData.quick_stats.currency || dashboardData.stats.currency || "USD";

  return (
    <motion.div
      className="relative w-full overflow-hidden rounded-xl border border-gray-800 bg-black p-4 sm:p-6 md:p-8 lg:p-10 text-white shadow-lg"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <div className="relative z-10">
        <div className="flex-grow pr-20 sm:pr-24 md:pr-32">
          <h3 className="text-base sm:text-lg md:text-xl uppercase font-light text-white mb-1">
            Sales Ops
          </h3>
          <h4 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light tracking-tight mb-2 break-words">
            {formatCurrency(totalPipelineValue, currency)}
          </h4>
          <p className="text-xs sm:text-sm text-white/80 uppercase">
            Total Pipeline Value
          </p>
        </div>
      </div>

      <div className="pointer-events-none absolute -bottom-2 -right-2 sm:-bottom-4 sm:-right-4 md:-right-6 w-32 h-24 sm:w-40 sm:h-32 md:w-48 md:h-36 lg:w-56 lg:h-40 opacity-90">
        <img
          src="https://www.thiings.co/_next/image?url=https%3A%2F%2Flftz25oez4aqbxpq.public.blob.vercel-storage.com%2Fimage-oKmcX6Scsb03ofRIcpVfqdCdpSBiC3.png&w=1000&q=75"
          alt="Dashboard illustration"
          className="w-full h-full object-contain"
        />
      </div>
    </motion.div>
  );
}